import {cx} from '@emotion/css';
import React, {ReactElement, ReactNode} from 'react';
import {Alignment} from '../../../../types';

import styles from './Headers.styles';

export enum HeaderType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export interface HeadersProps {
  alignment?: Alignment;
  children: ReactNode;
  className?: string;
  headerType: HeaderType;
  id?: string;
  testId?: string;
}

// @todo future work: spacing (margins etc), slim perhaps?

function Headers({alignment, children, className, headerType, id, testId}: HeadersProps): ReactElement {
  // @todo: remove .new-headers class

  const headerClassName = cx('new-headers', styles.header(alignment), className);

  switch (headerType) {
    case HeaderType.H2:
      return (
        <h2 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h2>
      );
    case HeaderType.H3:
      return (
        <h3 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h3>
      );
    case HeaderType.H4:
      return (
        <h4 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h4>
      );
    case HeaderType.H5:
      return (
        <h5 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h5>
      );
    case HeaderType.H6:
      return (
        <h6 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h6>
      );
    case HeaderType.H1:
    default:
      // default not required, there to satisfy switch statement rules
      return (
        <h1 className={headerClassName} id={id} data-testid={testId}>
          {children}
        </h1>
      );
  }
}

export default Headers;
